<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import { NOVA_AI_URL } from '@/config/external-links'
import { authSession } from '@/services/auth'

const accountPath = computed(() => authSession.isAuthenticated.value ? '/account' : '/login')
const accountLabel = computed(() => authSession.isAuthenticated.value ? '我的账号' : '账号入口')
</script>

<template>
  <footer class="site-footer">
    <div class="footer-main shell">
      <div class="footer-brand">
        <img class="footer-wordmark" src="/brand/nova-logo-full-white.png" alt="Nova·云枢" />
        <p>连接品牌、内容与商业，让每一个好故事都找到它的创作者。</p>
      </div>
      <nav class="footer-nav" aria-label="页脚导航">
        <RouterLink to="/works">精选作品</RouterLink>
        <RouterLink to="/tasks">接单广场</RouterLink>
        <RouterLink to="/courses">课程入口</RouterLink>
        <a :href="NOVA_AI_URL" target="_blank" rel="noopener">AI 创作平台</a>
        <RouterLink to="/#business">产品入口</RouterLink>
        <RouterLink :to="accountPath">{{ accountLabel }}</RouterLink>
      </nav>
    </div>
    <div class="footer-bottom shell">
      <span>© 2026 Nova·云枢。All rights reserved.</span>
      <nav class="footer-legal" aria-label="网站规则">
        <RouterLink to="/legal/privacy">隐私政策</RouterLink>
        <RouterLink to="/legal/agreement">用户协议</RouterLink>
        <RouterLink to="/legal/safety">内容安全规范</RouterLink>
      </nav>
    </div>
  </footer>
</template>
